/**
 * @generated SignedSource<<3f21eee004594036bd422cdc06c763eb>>
 * @relayHash c1b04759e5b09153deee6b2b9fb9afcf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9f8fd21eba2cf790d782ed412c437c5ce11bf46de81ad10141889884adef0374

import type { ConcreteRequest, Query } from 'relay-runtime';
export type LoomAuthTokenQuery$variables = Record<PropertyKey, never>;
export type LoomAuthTokenQuery$data = {
  readonly loomToken: {
    readonly token: string;
  } | null | undefined;
};
export type LoomAuthTokenQuery = {
  response: LoomAuthTokenQuery$data;
  variables: LoomAuthTokenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "LoomToken",
    "kind": "LinkedField",
    "name": "loomToken",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "token"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "LoomAuthTokenQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "LoomAuthTokenQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "c1b04759e5b09153deee6b2b9fb9afcf",
    "id": "9f8fd21eba2cf790d782ed412c437c5ce11bf46de81ad10141889884adef0374",
    "metadata": {},
    "name": "LoomAuthTokenQuery",
    "operationKind": "query",
    "text": "query LoomAuthTokenQuery{loomToken{token}}"
  }
};
})();

(node as any).hash = "cc249b7610e84f631da05d42ccd02363";

export default node;
